"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePayoutDestinationType = exports.PayoutPreferences = exports.ScheduleStatus = exports.PaymentPlatform = exports.MemberWorkFlowStatus = exports.ClientWorkFlowStatus = exports.Intervals = exports.InvoiceStatusPhase = exports.InvoiceStatus = exports.PaymentMethod = void 0;
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["Credit"] = "Credit";
    PaymentMethod["ACH"] = "ACH";
    PaymentMethod["Manual"] = "Manual";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["Draft"] = "Draft";
    InvoiceStatus["Open"] = "Open";
    InvoiceStatus["Overdue"] = "Overdue";
    InvoiceStatus["Cancelled"] = "Cancelled";
    InvoiceStatus["Pending"] = "Pending";
    InvoiceStatus["PaymentInTransit"] = "PaymentInTransit";
    InvoiceStatus["Paid"] = "Paid";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
var InvoiceStatusPhase;
(function (InvoiceStatusPhase) {
    InvoiceStatusPhase[InvoiceStatusPhase["Draft"] = 0] = "Draft";
    InvoiceStatusPhase[InvoiceStatusPhase["Open"] = 1] = "Open";
    InvoiceStatusPhase[InvoiceStatusPhase["Overdue"] = 2] = "Overdue";
    InvoiceStatusPhase[InvoiceStatusPhase["PaymentInTransit"] = 3] = "PaymentInTransit";
    InvoiceStatusPhase[InvoiceStatusPhase["Cancelled"] = 4] = "Cancelled";
    InvoiceStatusPhase[InvoiceStatusPhase["Paid"] = 5] = "Paid";
})(InvoiceStatusPhase = exports.InvoiceStatusPhase || (exports.InvoiceStatusPhase = {}));
var Intervals;
(function (Intervals) {
    Intervals["Week"] = "Week";
    Intervals["Month"] = "Month";
})(Intervals = exports.Intervals || (exports.Intervals = {}));
var ClientWorkFlowStatus;
(function (ClientWorkFlowStatus) {
    ClientWorkFlowStatus["Pending"] = "Pending";
    ClientWorkFlowStatus["PreApproved"] = "PreApproved";
    ClientWorkFlowStatus["Approved"] = "Approved";
    ClientWorkFlowStatus["PaymentInitiated"] = "PaymentInitiated";
    ClientWorkFlowStatus["Funded"] = "Funded";
    ClientWorkFlowStatus["Declined"] = "Declined";
})(ClientWorkFlowStatus = exports.ClientWorkFlowStatus || (exports.ClientWorkFlowStatus = {}));
var MemberWorkFlowStatus;
(function (MemberWorkFlowStatus) {
    MemberWorkFlowStatus["Disputed"] = "Disputed";
    MemberWorkFlowStatus["Accepted"] = "Accepted";
    MemberWorkFlowStatus["Resubmitted"] = "Resubmitted";
})(MemberWorkFlowStatus = exports.MemberWorkFlowStatus || (exports.MemberWorkFlowStatus = {}));
var PaymentPlatform;
(function (PaymentPlatform) {
    PaymentPlatform["Stripe"] = "Stripe";
    PaymentPlatform["Unit"] = "Unit";
    PaymentPlatform["CurrencyCloud"] = "CurrencyCloud";
    PaymentPlatform["Checkbook"] = "Checkbook";
    PaymentPlatform["WeGift"] = "WeGift";
})(PaymentPlatform = exports.PaymentPlatform || (exports.PaymentPlatform = {}));
var ScheduleStatus;
(function (ScheduleStatus) {
    ScheduleStatus["Pending"] = "Pending";
    ScheduleStatus["Completed"] = "Completed";
    ScheduleStatus["Skipped"] = "Skipped";
    ScheduleStatus["Modified"] = "Modified";
})(ScheduleStatus = exports.ScheduleStatus || (exports.ScheduleStatus = {}));
var PayoutPreferences;
(function (PayoutPreferences) {
    PayoutPreferences["Standard"] = "Standard";
    PayoutPreferences["Instant"] = "Instant";
    PayoutPreferences["Expedited"] = "Expedited";
    PayoutPreferences["Check"] = "Check";
    PayoutPreferences["ECheck"] = "ECheck";
})(PayoutPreferences = exports.PayoutPreferences || (exports.PayoutPreferences = {}));
;
var InvoicePayoutDestinationType;
(function (InvoicePayoutDestinationType) {
    InvoicePayoutDestinationType["Account"] = "Account";
    InvoicePayoutDestinationType["Card"] = "Card";
    InvoicePayoutDestinationType["InternalAccount"] = "InternalAccount";
    InvoicePayoutDestinationType["PaperCheck"] = "PaperCheck";
    InvoicePayoutDestinationType["WeGift"] = "WeGift";
})(InvoicePayoutDestinationType = exports.InvoicePayoutDestinationType || (exports.InvoicePayoutDestinationType = {}));
//# sourceMappingURL=invoice.js.map